import { Tracker, TrackingState } from '@/types/tracking';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CCP_KEY } from '../../../utils/constants';

const localStore = () => {
  if (!(window as any)._store) {
    (window as any)._store = {};
  }
  return (window as any)._store;
};

const initialState: TrackingState = {
  trackings: {}
};

export const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    addtracking: (state, action: PayloadAction<Tracker>) => {
      const CCP: any = window[CCP_KEY] || null;
      const tracker = { [action.payload.key]: { ...action.payload, timestamp: new Date().valueOf() } };
      if (CCP && CCP.consent) {
        const consented = tracker[action.payload.key].cookieConsentPolicies.every(
          (policy: string) => CCP.consent[policy]
        );
        if (consented) {
          (window as any)._addAttributionTrackerCookie(tracker[action.payload.key]);
        }
      }
      const trackings = {
        ...state.trackings,
        ...tracker
      };
      state.trackings = trackings;
      localStore().trackings = trackings;
    }
  }
});

export const { addtracking } = trackingSlice.actions;
export default trackingSlice.reducer;
